import Vue from "vue";
import * as types from "./mutation-types";

const mutations = {
  [types.SET_PROGRAM](state, programData) {
    state.coreProgramMeta = programData;
    state.programSettingsCopy = Vue._.cloneDeep(programData);
  },

  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_PROGRAM_LOADED](state, status) {
    state.programLoaded = status;
  },

  [types.UPDATE_META_VALUE](state, data) {
    state.coreProgramMeta[data.key] = data.value;
  },

  [types.UPDATE_SETTINGS_COPY_VALUE](state, data) {
    state.programSettingsCopy[data.key] = data.value;
  },

  [types.SET_TYPE_CORETIER](state, value) {
    state.isCoreTier = value;
  },

  [types.SET_TYPE_PLUSTIER](state, value) {
    state.isPlusTier = value;
  },

  [types.SET_TYPE_PROTIER](state, value) {
    state.isProTier = value;
  },

  [types.SET_TYPE_ACTIVATEPRODUCT](state, value) {
    state.isActivateProduct = value;
  },

  [types.SET_TYPE_ENGAGEPRODUCT](state, value) {
    state.isEngageProduct = value;
  },

  [types.SET_TYPE_THRIVEPRODUCT](state, value) {
    state.isThriveProduct = value;
  },

  [types.SET_TYPE_ACTIVITY](state, value) {
    state.isActivity = value;
  },

  [types.SET_TYPE_WELLNESS](state, value) {
    state.isWellness = value;
  },

  [types.SET_MAPS](state, maps) {
    state.maps = maps;
  },

  [types.SET_PROGRAM_TEAMS_RESPONSE_OBJECT](state, teams) {
    state.programTeamsResponseObject = teams;
  },

  [types.SET_PROGRAM_TEAMS](state, teams) {
    state.programTeams = teams;
  },

  [types.REMOVE_PROGRAM_TEAM](state, teamIndex) {
    state.programTeams.splice(teamIndex, 1);
  },

  [types.ADD_PROGRAM_TEAM](state, team) {
    state.programTeams.push(team);
  },

  [types.UPDATE_PROGRAM_TEAM](state, team) {
    const index = Vue._.findIndex(state.programTeams, { id: team.id });
    state.programTeams.splice(index, 1, team);
  },

  [types.SET_MEMBERS_RESPONSE_OBJECT](state, members) {
    state.membersResponseObject = members;
  },

  [types.SET_ADMIN_MEMBERS_RESPONSE_OBJECT](state, members) {
    state.adminMembersResponseObject = members;
  },

  [types.SET_CHALLENGES](state, challenges) {
    state.challenges = challenges;
  },

  [types.SET_ALL_CHALLENGES](state, allChallenges) {
    state.allChallenges = allChallenges;
  },

  [types.SET_FEATURED_CHALLENGES](state, featuredChallenges) {
    state.featuredChallenges = featuredChallenges;
  },

  [types.SET_ALL_FEATURED_CHALLENGES](state, featuredChallenges) {
    state.allFeaturedChallenges = featuredChallenges;
  },

  [types.SET_FEATURED_CHALLENGE](state, featuredChallenge) {
    if (!Vue._.isEmpty(featuredChallenge)) {
      // note, not all challenge routes have the map relation
      // assign allows use to use this mutation for those which don't have the maps relation
      // cloneDeep is needed for reactivity to propogate, which is otherwise trashed by assign
      let stateFeaturedChallengeCopy = Vue._.cloneDeep(state.featuredChallenge);
      state.featuredChallenge = Vue._.assign(
        stateFeaturedChallengeCopy,
        featuredChallenge
      );
    } else {
      state.featuredChallenge = {};
    }
  },

  [types.SET_ACTIVE_CHALLENGES](state, activeChallenges) {
    state.activeChallenges = activeChallenges;
  },

  [types.SET_PENDING_CHALLENGES](state, pendingChallenges) {
    state.pendingChallenges = pendingChallenges;
  },

  [types.SET_ARCHIVED_CHALLENGES](state, archivedChallenges) {
    state.archivedChallenges = archivedChallenges;
  },

  [types.REMOVE_ARCHIVED_CHALLENGE](state, challengeIndex) {
    state.archivedChallenges.data.splice(challengeIndex, 1);
  },

  [types.SET_ACTIVITIES](state, activities) {
    state.activities = activities;
  },

  [types.RESET_JOURNALS](state) {
    state.journals = [];
  },

  [types.IS_JOURNAL_LAST_PAGE](state, isLastPage) {
    state.isJournalLastPage = isLastPage;
  },

  [types.SET_JOURNALS](state, journals) {
    if (Array.isArray(journals)) {
      state.journals.push(...journals);
    } else {
      state.journals = journals;
    }
  },

  [types.SET_STEP_DATA](state, stepData) {
    state.stepData = stepData;
  },

  [types.SET_LEADERBOARD](state, leaderboard) {
    state.leaderboard = leaderboard;
  },

  [types.SET_AGGREGATE_DATA](state, aggregateData) {
    state.aggregateData = aggregateData;
  },

  [types.SET_MEMBERS](state, members) {
    state.members = members;
  },

  [types.REMOVE_MEMBER](state, memberId) {
    state.membersResponseObject.data = [
      ...Vue._.reject(state.membersResponseObject.data, { id: memberId })
    ];
  },

  [types.ADD_MEMBER](state, member) {
    state.membersResponseObject.data.push(member);
  },

  [types.SET_PROGRAM_QUESTIONS](state, programQuestions) {
    state.programQuestions = programQuestions;
  },

  [types.ADD_PROGRAM_QUESTION](state, question) {
    state.programQuestions.push(question);
  },

  [types.UPDATE_PROGRAM_QUESTION](state, question) {
    const index = Vue._.findIndex(state.programQuestions, { id: question.id });
    state.programQuestions.splice(index, 1, question);
  },

  [types.UPDATE_PROGRAM_QUESTIONS](state, questions) {
    for (const question of questions) {
      const index = Vue._.findIndex(state.programQuestions, {
        id: question.id
      });
      state.programQuestions.splice(index, 1, question);
    }
  },

  [types.REMOVE_PROGRAM_QUESTION](state, questionId) {
    const index = Vue._.findIndex(state.programQuestions, { id: questionId });
    state.programQuestions.splice(index, 1);
  },

  [types.SET_INCENTIVE_INTEGRATION](state, value) {
    state.isIncentiveIntegrationOn = value;
  },

  [types.SET_PROGRAM_ORGANIZATIONS](state, organizations) {
    state.programOrganizations = organizations;
  }
};

export default mutations;
